<template>
  <div class="support-page">
    <div class="page-wrapper">
      <h1 class="h1">Contact Us</h1>
      <p>
        If you are experiencing technical difficulties or have questions
        relating to the site, please contact us by completing the form below.
      </p>
      <v-form
        lazy-validation
        v-model="isFormValid"
        ref="form"
        @submit.prevent="submit"
      >
        <v-layout :wrap="['sm', 'xs'].includes($size)">
          <v-flex xs12 sm12 md6>
            <v-text-field
              v-model="form.first_name"
              :rules="[validation.required]"
              label="First name"
              validate-on-blur
            ></v-text-field>
          </v-flex>
          <v-flex class="px-3"></v-flex>
          <v-flex xs12 sm12 md6>
            <v-text-field
              v-model="form.last_name"
              :rules="[validation.required]"
              label="Last name"
              validate-on-blur
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout :wrap="['sm', 'xs'].includes($size)">
          <v-flex xs12 sm12 md6>
            <v-text-field
              v-model="form.email"
              :rules="[validation.required, validation.email]"
              type="email"
              label="Email address"
              validate-on-blur
            ></v-text-field>
          </v-flex>
          <v-flex class="px-3"></v-flex>
          <v-flex xs6></v-flex>
        </v-layout>
        <br />
        <v-textarea
          v-model="form.message"
          :rules="[validation.required]"
          label="Message"
          counter="500"
          maxlength="500"
          validate-on-blur
          outlined
        ></v-textarea>

        <v-btn :disabled="loading" large type="submit" color="primary">{{
          loading ? "Processing..." : "Submit"
        }}</v-btn>
        <br />
        <br />
        <Recaptcha />
      </v-form>
    </div>
  </div>
</template>

<script>
import formMixin from "@/mixins/form.mixin";

export default {
  name: "SupportPage",
  metaInfo: {
    titleTemplate: "%s - Support",
  },
  extends: formMixin,
  data() {
    return {
      loading: false,
      form: {},
    };
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        if (!this.validate()) return;
        await this.$recaptchaLoaded();
        const recaptcha = await this.$recaptcha("login");

        await this.$api.Support.create({ support: this.form, recaptcha });
        this.form = {};
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
